/** @jsx jsx */
import { jsx } from 'theme-ui';
import { Fragment, forwardRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-light-svg-icons';
import { Link, useLocation, useHistory } from 'react-router-dom';
import { Button } from './Button';
import { MenuToggleButton } from './MenuToggleButton';
export var MenuBar = forwardRef(function (_a, ref) {
    var backTo = _a.backTo, onOpenChange = _a.onOpenChange, showMenuButton = _a.showMenuButton, open = _a.open, children = _a.children;
    var location = useLocation();
    var history = useHistory();
    return (jsx("div", { ref: ref, sx: {
            p: 1,
            display: 'flex',
            flexDirection: ['row', 'column'],
            justifyContent: 'space-between',
            alignItems: 'center',
            flexShrink: 0,
        } }, backTo ? (jsx(Fragment, null,
        location.state ? (jsx(Button, { variant: "nav", size: "lg", onClick: function () {
                history.goBack();
            } },
            jsx(FontAwesomeIcon, { icon: faArrowLeft }))) : (jsx(Button, { variant: "nav", size: "lg", as: Link, to: backTo },
            jsx(FontAwesomeIcon, { icon: faArrowLeft }))),
        showMenuButton && (jsx(MenuToggleButton, { onOpenChange: onOpenChange, open: open })))) : (jsx(Fragment, null,
        showMenuButton && (jsx(MenuToggleButton, { onOpenChange: onOpenChange, open: open })),
        children))));
});
//# sourceMappingURL=MenuBar.js.map